const SOURCE_SEPARATOR = ' · '

export function episodeDisplayLabel(label: string): string {
    const separatorIndex = label.indexOf(SOURCE_SEPARATOR)
    return separatorIndex >= 0 ? label.slice(separatorIndex + SOURCE_SEPARATOR.length).trim() || label : label
}
